<template>
  <div>
    <Loader v-if="loading" text="" color="black" />
    <DetailsListCluster
      v-if="analysisItems.length > 0"
      :items="analysisItems"
      :page="page"
      :pageSize="pageSize"
      :matomo-category="analyticsCategory"
      theme="light"
      :height-percent="100"
      :height-pixels="0"
      :scroll-to-top="scrollToTop"
      @get-data="getAnalysis"
      @loaded="loading = false"
    ></DetailsListCluster>
    <h4 class="text-center" v-if="!loading && analysisItems.length === 0">
      {{ noDataText }}
    </h4>
  </div>
</template>

<script>
import { getArticles } from "@/services/search/wod.service";
import lodashCloneDeep from "lodash/cloneDeep";
import lodashIsEqual from "lodash/isEqual";
import lodashGet from "lodash/get";
import { nowUtc, daysAgo30Utc } from "@/common/date.utilities";
import { setInfiniteScrollState } from "@/common/basic.utilities";

export default {
  name: "AnalysisList",
  components: {
    DetailsListCluster: () =>
      import("@/components/common/details/DetailsListCluster"),
    Loader: () => import("@/components/common/Loader"),
  },
  props: {
    additionalParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
    noDataText: {
      type: String,
      default: "No Monthly Outlooks available",
    },
    analyticsCategory: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    analysisItems: [],
    page: 1,
    pageSize: 25,
    lastTimestamp: null,
    lastParams: {},
    loading: false,
    scrollToTop: new Date().toISOString(),
  }),
  computed: {
    start() {
      return daysAgo30Utc();
    },
    end() {
      return nowUtc();
    },
  },
  mounted() {
    this.getAnalysis();
  },
  methods: {
    async getAnalysis(page, $state) {
      if (typeof page !== "number") {
        this.scrollToTop = new Date().toISOString();
      }

      this.loading = true;
      const pageNum = typeof page === "number" ? page : this.page;
      const pageOffset = (pageNum - 1) * this.pageSize;

      const params = Object.assign(
        {
          sources: "analysis",
          start: this.start,
          end: this.end,
          pageSize: this.pageSize,
          pageOffset: pageOffset,
        },
        this.additionalParams
      );

      //Check if the query params are the same as the last query sent
      let prevParams = lodashCloneDeep(this.lastParams);
      if (!lodashIsEqual(params, prevParams)) {
        this.lastTimestamp = new Date().toISOString();
        this.lastParams = lodashCloneDeep(params);
      } else {
        this.loading = false;
        return;
      }

      try {
        const result = await getArticles(params, this.lastTimestamp);

        if (
          result &&
          result.features &&
          this.lastTimestamp ===
            lodashGet(
              result,
              "features[0].properties.formatted.requestTimestamp"
            )
        ) {
          if (
            Array.isArray(this.analysisItems) &&
            this.analysisItems.length &&
            pageNum !== 0 &&
            result.features
          ) {
            this.analysisItems = this.analysisItems.concat(result.features);
          } else if (result.features) {
            this.analysisItems = result.features;
          } else {
            this.analysisItems = [];
          }

          setInfiniteScrollState(
            $state,
            { features: this.analysisItems },
            "features"
          );
        } else {
          setInfiniteScrollState($state, { features: [] }, "features");
        }
      } catch (e) {
        console.error("Failed to retrieve analysis: ", e);
      } finally {
        this.loading = false;
      }
    },
    resetState() {
      this.lastParams = {};
      this.lastTimestamp = null;
      this.page = 1;
      this.loading = false;
      this.analysisItems = [];
    },
  },
  watch: {
    additionalParams: {
      async handler() {
        this.resetState();
        this.getAnalysis();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.hyp-scroll {
  overflow-y: hidden;
}
</style>
